import { Component, HostListener, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, ValidatorFn, Validators } from '@angular/forms';
import { EstadoDistribuidorOption, LeedService } from 'src/app/service/leed.service';
import { BannerLeedsService } from 'src/app/service/banner-leeds.service';
import { MensagemService } from 'src/app/service/mensagem.service';


@Component({
  selector: 'app-leeds',
  templateUrl: './leeds.component.html',
  styleUrls: ['./leeds.component.css']
})
export class LeedsComponent implements OnInit {
  form: FormGroup;
  popupForm: FormGroup;

  readonly estadosPorUf: { [uf: string]: string } = {
    AC: 'Acre',
    AL: 'Alagoas',
    AP: 'Amapá',
    AM: 'Amazonas',
    BA: 'Bahia',
    CE: 'Ceará',
    DF: 'Distrito Federal',
    ES: 'Espírito Santo',
    GO: 'Goiás',
    MA: 'Maranhão',
    MT: 'Mato Grosso',
    MS: 'Mato Grosso do Sul',
    MG: 'Minas Gerais',
    PA: 'Pará',
    PB: 'Paraíba',
    PR: 'Paraná',
    PE: 'Pernambuco',
    PI: 'Piauí',
    RJ: 'Rio de Janeiro',
    RN: 'Rio Grande do Norte',
    RS: 'Rio Grande do Sul',
    RO: 'Rondônia',
    RR: 'Roraima',
    SC: 'Santa Catarina',
    SP: 'São Paulo',
    SE: 'Sergipe',
    TO: 'Tocantins'
  };

  estados: EstadoDistribuidorOption[] = [];
  cidades: string[] = [];

  carregandoCep = false;
  mensagemPopup = '';
  distribuidorEncontrado = false;
  distribuidorId: string = null;
  readonly mensagemSemDistribuidor = '⚠️ Ainda estamos ampliando nossa rede de distribuidores nesta região.';

  mensagemSucesso = '';
  mensagemErro = '';
  enviando = false;
  exibirPopupConfirmacaoDuplicado = false;
  mensagemPopupConfirmacaoDuplicado = 'O CPF informado já encaminhou o Pré-cadastro, deseja continuar? ';
  private payloadConfirmacaoDuplicado: any = null;
  private desktopDataSourceSlider: string[] = [];
  private mobileDataSourceSlider: string[] = [];
  public _dataSourceSlider: string[] = [];
  public isMobile = false;
  public sliderLinks;

  constructor(private fb: FormBuilder, private leedService: LeedService, private bannerLeedsService: BannerLeedsService, private msg: MensagemService) { }

  ngOnInit() {
    this.updateDeviceMode();
    this.popupForm = this.fb.group({
      estado: ['', Validators.required],
      cidade: ['', Validators.required]
    });

    this.form = this.fb.group({
      nome: ['', [Validators.required, this.nomeValidator()]],
      cpf: ['', [Validators.required, this.cpfValidator()]],
      nascimento: ['', [Validators.required, this.dataValidator()]],
      endereco: [''],
      bairro: [''],
      cep: ['', [Validators.required, this.cepValidator()]],
      whatsapp: ['', [Validators.required, this.whatsappValidator()]],
      email: ['', [Validators.required, Validators.email]],
      jaERevendedor: [false],
      marcasTrabalho: [''],
      formaPagamentoPedido: ['', Validators.required],
      aceiteTermos: [false, Validators.requiredTrue]
    });

    this.configurarMascaras();
    this.carregarEstados();
    this.carregarBanner();
  }

  public get dataSourceSlider(): string[] {
    return this._dataSourceSlider;
  }

  public galeryClick(it) {
    if (this.sliderLinks) {
      if (this.sliderLinks.length >= (it.itemIndex + 1)) {
        var url = this.sliderLinks[it.itemIndex];
        if (url) {
          window.open(url, '_blank');
        }
      }
    }
  }

  private carregarBanner() {
    this.bannerLeedsService.GetSlider().subscribe(sl => {
      const dataSourceDesktop: string[] = [];
      const dataSourceMobile: string[] = [];
      const sliderLinks: Array<string | null> = [];

      if (sl) {
        sl.forEach(s => {
          const desktopPath = 'https://cdn.simplifica.top/facinatus/leeds/' + s.itemBannerCadastroId + '/slider.jpg';
          const mobilePath = 'https://cdn.simplifica.top/facinatus/leeds/' + s.itemBannerCadastroId + '/slidermobile.jpg';

          dataSourceDesktop.push(desktopPath);
          dataSourceMobile.push(mobilePath);
          sliderLinks.push(s.url);
        });
      }

      if (!dataSourceDesktop.length) {
        dataSourceDesktop.push('assets/bannerRevendedora.jpg');
        dataSourceMobile.push('assets/bannerRevendedora.jpg');
        sliderLinks.push(null);
      }

      this.desktopDataSourceSlider = dataSourceDesktop;
      this.mobileDataSourceSlider = dataSourceMobile;
      this.applyBannerByDevice();
      this.sliderLinks = sliderLinks;
    });
  }

  @HostListener('window:resize')
  onResize() {
    this.updateDeviceMode();
    this.applyBannerByDevice();
  }

  private updateDeviceMode() {
    this.isMobile = window.innerWidth <= 991;
  }

  private applyBannerByDevice() {
    this._dataSourceSlider = this.isMobile
      ? this.mobileDataSourceSlider.slice()
      : this.desktopDataSourceSlider.slice();
  }

  private configurarMascaras() {
    this.form.get('nome').valueChanges.subscribe((valor: string) => {
      const sanitizado = this.apenasLetrasComEspacos(valor);
      if (valor !== sanitizado) {
        this.form.get('nome').setValue(sanitizado, { emitEvent: false });
      }
    });

    this.form.get('cpf').valueChanges.subscribe((valor: string) => {
      const mascarado = this.aplicarMascaraCpf(valor);
      if (valor !== mascarado) {
        this.form.get('cpf').setValue(mascarado, { emitEvent: false });
      }
    });

    this.form.get('cep').valueChanges.subscribe((valor: string) => {
      const mascarado = this.aplicarMascaraCep(valor);
      if (valor !== mascarado) {
        this.form.get('cep').setValue(mascarado, { emitEvent: false });
      }
    });

    this.form.get('whatsapp').valueChanges.subscribe((valor: string) => {
      const mascarado = this.aplicarMascaraWhatsapp(valor);
      if (valor !== mascarado) {
        this.form.get('whatsapp').setValue(mascarado, { emitEvent: false });
      }
    });

    this.form.get('nascimento').valueChanges.subscribe((valor: string) => {
      const mascarado = this.aplicarMascaraData(valor);
      if (valor !== mascarado) {
        this.form.get('nascimento').setValue(mascarado, { emitEvent: false });
      }
    });
  }

  carregarEstados() {
    this.leedService.getEstados().subscribe((res: EstadoDistribuidorOption[]) => {
      this.estados = res || [];
    });
  }

  onEstadoPopupChange() {
    this.popupForm.patchValue({ cidade: '' });
    this.cidades = [];
    this.mensagemPopup = '';
    this.distribuidorEncontrado = false;
    this.distribuidorId = null;

    var estado = this.popupForm.get('estado').value;
    if (!estado) {
      return;
    }

    this.leedService.getCidades(estado).subscribe((res: any) => {
      this.cidades = res || [];
      if (!this.cidades.length) {
        this.mensagemPopup = this.mensagemSemDistribuidor;
      }
    });
  }

  onCidadePopupChange() {
    var estado = this.popupForm.get('estado').value;
    var cidade = this.popupForm.get('cidade').value;

    this.mensagemPopup = '';
    this.distribuidorEncontrado = false;
    this.distribuidorId = null;

    if (!estado || !cidade) {
      if (estado && !this.cidades.length) {
        this.mensagemPopup = this.mensagemSemDistribuidor;
      }
      return;
    }

    this.leedService.getDistribuidor(estado, cidade).subscribe((res: any) => {
      if (res && res.sucesso && res.item) {
        this.distribuidorEncontrado = true;
        this.distribuidorId = res.item.usuarioId;
        this.mensagemPopup = '✅ Há um distribuidor responsável pela sua região.';
      } else {
        this.distribuidorEncontrado = false;
        this.mensagemPopup = this.mensagemSemDistribuidor;
      }
    });
  }

  private selecionarEstadoDistribuidorPorCep(estadoRetornoCep: string) {
    const estado = this.obterEstadoDistribuidorPorEntrada(estadoRetornoCep);
    if (!estado) {
      return;
    }

    this.popupForm.patchValue({ estado: estado.estadoId, cidade: '' });
    this.onEstadoPopupChange();
  }

  private obterEstadoDistribuidorPorEntrada(estado: string): EstadoDistribuidorOption {
    const estadoNormalizado = (estado || '').trim().toUpperCase();
    const nomeEstado = (this.estadosPorUf[estadoNormalizado] || estado || '').trim().toUpperCase();

    return this.estados.find(item => {
      const id = (item.estadoId || '').trim().toUpperCase();
      const nome = (item.nome || '').trim().toUpperCase();
      return id === estadoNormalizado || nome === nomeEstado || nome === estadoNormalizado;
    });
  }

  private obterNomeEstadoDistribuidorSelecionado(): string {
    const estadoId = this.popupForm.get('estado').value;
    const estado = this.estados.find(item => item.estadoId === estadoId);
    return estado ? estado.nome : estadoId;
  }

  buscarCep() {
    this.mensagemErro = '';
    const cep = this.apenasNumeros(this.form.get('cep').value);

    if (!cep || cep.length !== 8) {
      return;
    }

    this.carregandoCep = true;
    this.leedService.buscarCep(cep).subscribe((res: any) => {
      this.carregandoCep = false;

      if (res && res.sucesso && res.item) {
        const estadoRetornoCep = (res.item.estado || '').trim();
        this.form.patchValue({
          endereco: res.item.endereco || this.form.get('endereco').value,
          bairro: res.item.bairro || this.form.get('bairro').value,
          cep: this.aplicarMascaraCep(res.item.cep || this.form.get('cep').value)
        });

        this.selecionarEstadoDistribuidorPorCep(estadoRetornoCep);
      } else {
        this.mensagemErro = (res && res.msg) ? res.msg : 'Não foi possível localizar o CEP informado.';
      }
    }, () => {
      this.carregandoCep = false;
      this.mensagemErro = 'Não foi possível localizar o CEP informado.';
    });
  }

  private marcarCamposComoTocados(group: FormGroup) {
    Object.keys(group.controls).forEach(campo => {
      var control = group.get(campo);
      control.markAsTouched();
    });
  }

  enviar() {
    this.mensagemSucesso = '';
    this.mensagemErro = '';

    if (this.form.invalid) {
      this.marcarCamposComoTocados(this.form);
      if (this.form.get('email').invalid) {
        this.mensagemErro = 'Informe um E-mail válido.';
        return;
      }
      if (this.form.get('cpf').invalid) {
        this.mensagemErro = 'Informe um CPF válido.';
        return;
      }
      if (this.form.get('cep').invalid) {
        this.mensagemErro = 'Informe um CEP válido.';
        return;
      }
      if (this.form.get('whatsapp').invalid) {
        this.mensagemErro = 'Informe um WhatsApp válido.';
        return;
      }
      if (this.form.get('nascimento').invalid) {
        this.mensagemErro = 'Informe uma Data nascimento válida no formato dd/MM/yyyy.';
        return;
      }
      if (this.form.get('nome').invalid) {
        this.mensagemErro = 'Informe um nome válido contendo apenas letras.';
        return;
      }
      if (this.form.get('formaPagamentoPedido').invalid) {
        this.mensagemErro = 'Selecione a forma de pagamento do pedido.';
        return;
      }
      this.mensagemErro = 'Preencha os campos obrigatórios e aceite os termos.';
      return;
    }

    if (this.popupForm.invalid) {
      this.marcarCamposComoTocados(this.popupForm);
      this.mensagemErro = 'Selecione o estado e a cidade que deseja revender.';
      return;
    }

    if (!this.distribuidorId) {
      this.mensagemErro = 'Não é possível enviar sem distribuidor identificado para a região.';
      return;
    }

    var payload = Object.assign({}, this.form.value);
    payload.estado = this.obterNomeEstadoDistribuidorSelecionado();
    payload.cidade = this.popupForm.get('cidade').value;
    payload.cpf = this.apenasNumeros(payload.cpf);
    payload.cep = this.apenasNumeros(payload.cep);
    payload.whatsapp = this.apenasNumeros(payload.whatsapp);
    payload.nascimento = this.dataParaFormatoIso(payload.nascimento);
    payload.distribuidorId = this.distribuidorId;

    this.enviarCadastro(payload);
  }

  confirmarAtualizacaoCpfDuplicado() {
    if (!this.payloadConfirmacaoDuplicado) {
      this.exibirPopupConfirmacaoDuplicado = false;
      return;
    }

    const payload = Object.assign({}, this.payloadConfirmacaoDuplicado, { confirmarAtualizacaoDuplicado: true });
    this.exibirPopupConfirmacaoDuplicado = false;
    this.enviarCadastro(payload);
  }

  cancelarAtualizacaoCpfDuplicado() {
    this.exibirPopupConfirmacaoDuplicado = false;
    this.payloadConfirmacaoDuplicado = null;
  }

  private enviarCadastro(payload: any) {
    this.enviando = true;
    this.leedService.cadastrar(payload).subscribe((res: any) => {
      this.enviando = false;
      if (res && res.sucesso) {
        this.mensagemSucesso = (res && res.atualizacaoDuplicado) ? 'Pré-cadastro atualizado com sucesso!' : 'Pré-cadastro enviado com sucesso!';
        this.form.reset({ jaERevendedor: false, aceiteTermos: false });
        this.popupForm.reset({ estado: '', cidade: '' });
        this.cidades = [];
        this.mensagemPopup = '';
        this.distribuidorEncontrado = false;
        this.distribuidorId = null;
        this.payloadConfirmacaoDuplicado = null;
        this.exibirPopupConfirmacaoDuplicado = false;
        this.msg.Sucesso(this.mensagemSucesso);
      } else {
        this.tratarErroCadastro(payload, res);
      }
    }, (erro) => {
      this.enviando = false;
      this.tratarErroCadastro(payload, erro && erro.error ? erro.error : null);
    });
  }

  private tratarErroCadastro(payload: any, resposta: any) {
    if (resposta && resposta.requerConfirmacao) {
      this.payloadConfirmacaoDuplicado = Object.assign({}, payload);
      this.exibirPopupConfirmacaoDuplicado = true;
      this.mensagemErro = '';
      return;
    }

    const msg = (resposta && (resposta.msg || (resposta.erros && resposta.erros.join(' ')))) || 'Falha ao enviar Pré-cadastro.';
    this.mensagemErro = this.normalizarMensagemErroCadastro(msg);
    this.msg.Error(this.mensagemErro);
  }

  private normalizarMensagemErroCadastro(mensagem: string): string {
    if (mensagem === 'CPF já cadastrado.') {
      return 'Não foi possível criar o pré-cadastro, CPF já cadastrado';
    }

    return mensagem;
  }

  private apenasNumeros(texto: string): string {
    return (texto || '').replace(/\D/g, '');
  }

  private aplicarMascaraCpf(valor: string): string {
    const digitos = this.apenasNumeros(valor).slice(0, 11);
    return digitos
      .replace(/(\d{3})(\d)/, '$1.$2')
      .replace(/(\d{3})(\d)/, '$1.$2')
      .replace(/(\d{3})(\d{1,2})$/, '$1-$2');
  }

  private aplicarMascaraCep(valor: string): string {
    const digitos = this.apenasNumeros(valor).slice(0, 8);
    return digitos.replace(/(\d{5})(\d{1,3})$/, '$1-$2');
  }

  private aplicarMascaraWhatsapp(valor: string): string {
    const digitos = this.apenasNumeros(valor).slice(0, 11);
    if (digitos.length <= 2) {
      return digitos;
    }

    if (digitos.length <= 6) {
      return '(' + digitos.slice(0, 2) + ') ' + digitos.slice(2);
    }

    if (digitos.length <= 10) {
      return '(' + digitos.slice(0, 2) + ') ' + digitos.slice(2, 6) + '-' + digitos.slice(6);
    }

    return '(' + digitos.slice(0, 2) + ') ' + digitos.slice(2, 7) + '-' + digitos.slice(7);
  }

  private aplicarMascaraData(valor: string): string {
    const digitos = this.apenasNumeros(valor).slice(0, 8);
    if (digitos.length <= 2) {
      return digitos;
    }

    if (digitos.length <= 4) {
      return digitos.slice(0, 2) + '/' + digitos.slice(2);
    }

    return digitos.slice(0, 2) + '/' + digitos.slice(2, 4) + '/' + digitos.slice(4);
  }

  private apenasLetrasComEspacos(texto: string): string {
    return (texto || '').replace(/[^A-Za-zÀ-ÖØ-öø-ÿ\s]/g, '');
  }

  private nomeValidator(): ValidatorFn {
    return (control: AbstractControl) => {
      const nome = (control.value || '').trim();
      if (!nome) {
        return null;
      }

      return /^[A-Za-zÀ-ÖØ-öø-ÿ\s]+$/.test(nome) ? null : { nomeInvalido: true };
    };
  }

  private cpfValidator(): ValidatorFn {
    return (control: AbstractControl) => {
      const cpf = this.apenasNumeros(control.value || '');

      if (!cpf) {
        return null;
      }

      if (cpf.length !== 11 || /(\d)\1{10}/.test(cpf)) {
        return { cpfInvalido: true };
      }

      let soma = 0;
      let resto;

      for (let i = 1; i <= 9; i++) {
        soma = soma + parseInt(cpf.substring(i - 1, i), 10) * (11 - i);
      }

      resto = (soma * 10) % 11;
      if ((resto === 10) || (resto === 11)) {
        resto = 0;
      }

      if (resto !== parseInt(cpf.substring(9, 10), 10)) {
        return { cpfInvalido: true };
      }

      soma = 0;
      for (let i = 1; i <= 10; i++) {
        soma = soma + parseInt(cpf.substring(i - 1, i), 10) * (12 - i);
      }

      resto = (soma * 10) % 11;
      if ((resto === 10) || (resto === 11)) {
        resto = 0;
      }

      if (resto !== parseInt(cpf.substring(10, 11), 10)) {
        return { cpfInvalido: true };
      }

      return null;
    };
  }

  private cepValidator(): ValidatorFn {
    return (control: AbstractControl) => {
      const cep = this.apenasNumeros(control.value || '');
      if (!cep) {
        return null;
      }
      return cep.length === 8 ? null : { cepInvalido: true };
    };
  }

  private whatsappValidator(): ValidatorFn {
    return (control: AbstractControl) => {
      const whatsapp = this.apenasNumeros(control.value || '');
      if (!whatsapp) {
        return null;
      }
      return whatsapp.length >= 10 && whatsapp.length <= 11 ? null : { whatsappInvalido: true };
    };
  }

  private dataValidator(): ValidatorFn {
    return (control: AbstractControl) => {
      const data = (control.value || '').trim();
      if (!data) {
        return null;
      }

      const match = /^(\d{2})\/(\d{2})\/(\d{4})$/.exec(data);
      if (!match) {
        return { dataInvalida: true };
      }

      const dia = parseInt(match[1], 10);
      const mes = parseInt(match[2], 10);
      const ano = parseInt(match[3], 10);
      const date = new Date(ano, mes - 1, dia);

      if (date.getFullYear() !== ano || date.getMonth() !== mes - 1 || date.getDate() !== dia) {
        return { dataInvalida: true };
      }

      return null;
    };
  }

  private dataParaFormatoIso(data: string): string {
    const match = /^(\d{2})\/(\d{2})\/(\d{4})$/.exec(data || '');
    if (!match) {
      return data;
    }

    return match[3] + '-' + match[2] + '-' + match[1];
  }
}
